module.exports = __webpack_public_path__ + "static/img/IR.f6eb0772.svg";